<template>
  <div class="ocrBusinessCardCom" >
    <input v-if="browserType === 'weixin' || browserType === 'baiduboxapp'" type="file" ref="imageInput" @change="handleImageInput" accept="image/*"  style="display:none;" >
    <input v-else type="file" ref="imageInput" @change="handleImageInput" accept="image/*" capture="camera"  style="display:none;" >

    <div class="border1"></div>

    <cameraBtn @click.native="cameraBtnClick" :btnText="cameraBtnText" :w="businessCardWidth"></cameraBtn>

    <div @click="cameraBtnClick" style="cursor: pointer;">
      <img class="businessCard" src="../images/business-card.jpg" alt="" :style="{ width: businessCardWidth / 37.5 + 'rem' }">
    </div>

    <van-popup v-model="ocrFailShow">
      <ocrFail @cameraBtnClick="cameraBtnClick"></ocrFail>
    </van-popup>
  </div>
</template>

<script>
import lrz from 'lrz'
import ocrBusinessCard from '../api/ocrBusinessCard'
import cameraBtn from './cameraBtn'
import ocrFail from './ocrFail'
import getBrowserType from '../utils/getBrowserType'
import userBehaviorLogs from '../api/userBehaviorLogs'
export default {
  name: 'ocrBusinessCardCom',
  components: { cameraBtn, ocrFail },
  data () {
    return {
      browserType: getBrowserType(),
      cameraBtnText: '拍名片快速报名',
      businessCardWidth: 260,
      ocrFailShow: false // 识别失败，或者识别有效内容为空
    }
  },
  methods: {
    cameraBtnClick () {
      this.ocrFailShow = false
      this.$refs.imageInput.click()
    },
    clearInputValue () {
      let file = this.$refs.imageInput
      try {
        file.value = ''
        if (file.value) {
          file.type = 'text'
          file.type = 'file'
        }
      } catch (e) {}
    },
    handleImageInput (e) {
      this.$toast.loading({
        mask: true,
        message: '名片识别中...',
        duration: 0
      })
      let uploadImage = e.currentTarget.files[0]
      console.log(uploadImage)
      userBehaviorLogs({ op_event: '名片识别请求' })
      lrz(uploadImage, { width: 800 })
        .then(data => {
          let imageBase64 = data.base64 ? data.base64.slice(23) : ''
          if (!imageBase64) {
            return
          }
          this.getBusinessCardInfo(imageBase64)
        })
    },
    getBusinessCardInfo (base64) {
      ocrBusinessCard(base64)
        .then(data => {
          console.log('名片信息', data)
          userBehaviorLogs({ op_event: '名片识别成功' })
          this.inputBusinessCardData(data, base64)
          this.clearInputValue()
          this.$toast.success({
            mask: true,
            duration: 500,
            message: '识别成功'
          })
        })
        .catch(err => {
          console.log('获取名片信息失败')
          userBehaviorLogs({ op_event: '名片识别失败' })
          this.clearInputValue()
          this.ocrFailShow = true
          this.$toast.fail({
            mask: true,
            duration: 1000,
            message: '请重新尝试'
          })
        })
    },
    inputBusinessCardData (data, base64) {
      let formData = {}
      formData.name = data.name
      formData.phone = handleOneInfo(data.tel_cell)
      formData.position = handleOneInfo(data.title)
      formData.company = handleOneInfo(data.company)

      let hasValidData = Object.keys(formData).some(key => {
        return formData[key]
      })

      if (!hasValidData) {
        this.ocrFailShow = true
        return
      }

      this.$emit('inputBusinessCardData', formData, base64)

      function handleOneInfo (itemInfo) {
        return Array.isArray(itemInfo) ? itemInfo[0] : ''
      }
    }
  }
}
</script>

<style scoped lang="less">
  @import "../less/variable";
  .ocrBusinessCardCom {
    .pb(20);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    .border1 {
      .w(350);
      margin: 10px auto 0;
      border-top: 1px solid #999;
    }
    .businessCard {
      margin-top: 10px;
      .w(@businessCardWidth);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ocrBusinessCardCom.vue